import dayjs from 'dayjs';
import { request } from '../../request';

type CheckOverlapForCreateProps = {
  startDate: dayjs.Dayjs;
  endDate: dayjs.Dayjs;
  timeZone: string;
  staffingType: 'All' | 'Internal' | 'External';
  isUrgent: boolean;
  departmentNodeId: string;
  subDepartmentNodeId?: string;
  locationId: string;
  qualificationIds: string[];
  specialtyId?: string;
  assigneeId: string[];
};

type CheckOverlapForCreateRequest = Omit<CheckOverlapForCreateProps, 'startDate' | 'endDate' | 'specialtyId'> & {
  startDate: string;
  endDate: string;
  specialityId: string | null;
  assigneeIds: string[];
};

export async function checkOverlapForCreate(data: CheckOverlapForCreateProps): Promise<CheckOverlapForCreateResponse> {
  const requestData: CheckOverlapForCreateRequest = {
    ...data,
    startDate: data.startDate.toServerDateTimeFormat(),
    endDate: data.endDate.toServerDateTimeFormat(),
    specialityId: data.specialtyId || null,
    assigneeIds: data.assigneeId,
  };
  const response = await request.get<CheckOverlapForCreateResponse>('/v2/shifts/overlap-check-for-create', {
    params: requestData,
  });

  return response.data;
}

export const checkOverlapForAssign = checkOverlapForUpdate;

type CheckOverlapForCreateResponse = {
  canCreateDoubleShift: true;
  overlappedShiftId: string | null;
};

type CheckOverlapForUpdateProps = {
  shiftID: string;
  assigneeId: string;
};

export async function checkOverlapForUpdate(data: CheckOverlapForUpdateProps): Promise<CheckOverlapForUpdateResponse> {
  const response = await request.get<CheckOverlapForUpdateResponse>(
    `/v2/shifts/${data.shiftID}/overlap-check-for-update`,
    {
      params: {
        assigneeId: data.assigneeId,
      },
    },
  );
  return response.data;
}

type CheckOverlapForUpdateResponse = {
  canCreateDoubleShift: true;
  overlappedShiftId: string | null;
};
